import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=0d77525d&scoped=true"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"
import style0 from "./Message.vue?vue&type=style&index=0&id=0d77525d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d77525d",
  null
  
)

export default component.exports